import confirmationModalIcon from "./images/confirmationModal.svg";
import emptyContentIcon from "./images/emptyContent.svg";
export { default } from "./welcomePanel";
export { confirmationModalIcon, emptyContentIcon };
